const prod = {
	apiEndpoint: 'https://api.rocketium.com',
	url: 'https://rocketium.com'
};

const dev = {
	apiEndpoint: 'https://devapitest.rocketium.com',
	url: 'https://dev.rocketium.com'
};

const local = {
	apiEndpoint: 'http://localhost:3000',
	url: 'http://localhost:3000'
};

export default prod;